import { render } from "./RentableItemList.vue?vue&type=template&id=2d004da6&scoped=true"
import script from "./RentableItemList.vue?vue&type=script&lang=js"
export * from "./RentableItemList.vue?vue&type=script&lang=js"

import "./RentableItemList.vue?vue&type=style&index=0&id=2d004da6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d004da6"]])

export default __exports__